import {
    Icon,
    Menu,
    MenuItemOption,
    MenuOptionGroup,
    Popover,
    PopoverAnchor,
    stopEvent,
    useVisibility,
} from '@fold-dev/core'
import { TbList, TbMenu4 } from 'react-icons/tb'
import { ActionButton } from './'

export type ListOption = { value: string; label: string }

export type ListButtonProps = {
    list?: number
    options?: ListOption[]
    title?: string
    onChange: (val) => void
    portal?: any
    icon?: any
    anchor?: PopoverAnchor
    disabled?: boolean
}

export const ListButton = (props: ListButtonProps) => {
    const { options, disabled, list = 0, title = 'Select list', onChange, portal, icon = TbMenu4, anchor } = props
    const { visible, show, hide } = useVisibility(false)

    return (
        <Popover
            portal={portal}
            focusTrap
            width={200}
            anchor={anchor}
            content={
                <Menu
                    width="100%"
                    border="none">
                    <MenuOptionGroup
                        onChange={(optionValue: any) => {
                            const list = options.findIndex((item) => item.value == optionValue)
                            onChange(list)
                            hide()
                        }}
                        title={title}
                        defaultValue={options[list]?.value}
                        type="radio">
                        {options.map(({ value, label }, index) => (
                            <MenuItemOption
                                key={index}
                                value={value}>
                                {label}
                            </MenuItemOption>
                        ))}
                    </MenuOptionGroup>
                </Menu>
            }
            isVisible={visible}
            onDismiss={hide}>
            <div
                className="f-row action-button-parent"
                style={{
                    gap: 5,
                }}>
                <ActionButton
                    disabled={disabled}
                    border
                    onClick={show}>
                    <Icon
                        icon={icon}
                        size="sm"
                    />
                </ActionButton>
                <div
                    onClick={(e) => {
                        if (disabled) return
                        stopEvent(e)
                        show()
                    }}
                    className="f-text sm"
                    style={{ color: disabled ? 'var(--f-color-text-weakest)' : 'var(--f-color-text-weaker)' }}>
                    {options[list]?.label}
                </div>
            </div>
        </Popover>
    )
}
